import CityPageTemplate from "../city-template/CityPageTemplate";
import { grandBlancConfig } from "./data";

export default function GrandBlancPage() {
  return <CityPageTemplate config={grandBlancConfig} />;
}